import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from "apis/permission";
type ApiAuthPermissionOutputProps = OutputBaseProps<PermissionItemProps[]>
export const apiAuthPermission = async () => {
    const res = (await axios.get<ApiAuthPermissionOutputProps>(`/api/auth/user-permission`))
        .data;
    return res;
};
